import state from './moduleUserDepartmentState'
import actions from './moduleUserDepartmentActions'
import getters from './moduleUserDepartmentGetters'
import mutations from './moduleUserDepartmentMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
